export default __webpack_public_path__ + "28cff67.png";